import React from 'react';

type ButtonWithIconProps = {
    id?: string;
    text: string;
    showIcon: boolean;
    iconUrl?: string;
    showTooltip: boolean;
    tooltipText?: string;
    className?: string;
    onClick?: () => void;
};

/**
 * Reusable button component with optional icon and tooltip
 * Used in HeaderSection for Reset and Close buttons
 */
export const ButtonWithIcon = ({
    id,
    text,
    showIcon,
    iconUrl,
    showTooltip,
    tooltipText,
    className = 'popup-button-outline',
    onClick
}: ButtonWithIconProps) => {
    return (
        <button
            id={id}
            data-testid={id}
            className={className}
            title={showTooltip ? tooltipText : undefined}
            onClick={onClick}
        >
            {showIcon && iconUrl && (
                <img
                    id={id ? `${id}-icon` : undefined}
                    src={iconUrl}
                    alt={`${text} icon`}
                    loading="lazy"
                    className="tw-w-4 tw-h-4 tw-inline-block tw-mr-1"
                />
            )}
            {text}
        </button>
    );
};
